import React, { Component } from 'react';
// elements
import IconButton from 'material-ui/IconButton';
import ContextIconMenu from '../Common/ContextIconMenu';
import { Link } from 'react-router';
import { ListItem } from 'material-ui/List';
// icons
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import InfoIcon from 'material-ui/svg-icons/action/info';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import VendorIcon from 'material-ui/svg-icons/places/business-center';
// constants
import * as Colors from 'material-ui/styles/colors';
import { statusColours } from '../../constants/ColourConstants';

import ROLES from '../../constants/Roles';
// business logic
import VendorActions from '../../actions/VendorActionCreator';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    menuItem: {
        color: '#CC0000',
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

class VendorListItem extends Component {

    getActions(row) {
        return [
            {
                link: `/dashboard/vendor/${row.id}`,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                type:'divider'
            },
            {
                link: `/dashboard/vendor/${row.id}/edit`,
                label: 'Edit',
                icon: <EditIcon />,
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: row.id,
                title: 'Delete course',
                deleteAction: VendorActions.delete,
                message: (
                            <span>
                                Are you sure to delete the category "{row.name}" ?
                            </span>
                        ),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    }

    render() {

        const infoLink = `/dashboard/vendor/${this.props.data.id}`;

        const leftAvatar = <Link to={infoLink} >
            <VendorIcon style={style.icon} color={statusColours.primary} />
        </Link>;

        const itemProps = {
            style: style.listItem,
            primaryText: <Link to={infoLink} className="primaryText">{this.props.data.name}</Link>,
            leftAvatar: leftAvatar,
            secondaryTextLines: 2
        };

        const actions = this.getActions(this.props.data);
        if (!!actions && actions.length > 0) {
            const iconButton = <IconButton touch={true} style={style.iconButton} >
                <MoreVertIcon color={Colors.grey400} />
            </IconButton>;

            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                actions,
                data: this.props.data,
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
                iconButtonElement: iconButton,
            };
            itemProps.rightIcon = <ContextIconMenu {...iconMenuProps} />;
        }

        if (this.props.data.loading) {
            // show loading bar
        } else {
            let description = (this.props.data.description || '');
            if (description.length > 50) {
                description = description.substr(0, 45) + '…';
            }
            itemProps.secondaryText = <span>{description}</span>;
        }

        return <ListItem {...itemProps} />
    }
}

export default VendorListItem;

